import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from '@/services/instance'

export default class ElasticSearchSourceService {
  static async list(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ElasticSearchSource/list', payload)
    )
    return Callback(err, res)
  }
  static async fullSearch(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ElasticSearchSource/full-search?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async detail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ElasticSearchSource/detail?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getBasicInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/get_basic_info?stdClassId=${payload.stdClassId}`)
    )
    return Callback(err, res)
  }
  static async getClassRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassRelation/get_class_relation?stdClassId=${payload.stdClassId}`
      )
    )
    return Callback(err, res)
  }
  static async getChangeRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdChangeRecord?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getClassAttribute(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_std_class_attribute_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getClassAttributeData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_std_class_attribute_data_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async upDateEsData() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/ElasticSearchSource/from_mysql_import_To_elasticsearch')
    )
    return Callback(err, res)
  }
}
